// The default export of `hocs` is the Redux-connected `ForgeElement`, which
// injects the current portal's `projectId` so portal-page Forge modules send
// the portal resource context with their fetch-extensions request.
export { default as ForgeElement } from './ui/hocs';
